// Generated by CoffeeScript 2.7.0
var Libs;

import CurrentAttributes from './current_attributes/index.js';

import DomMaster from './dom-master/index.js';

import Ajax from './ajax.js';

import Clipboard from './clipboard.js';

import FileUploader from './file_uploader.js';

import Geolocation from './geolocation.js';

import GlobalID from './global_id.js';

import {
  HierarchicalTreeNode,
  HierarchicalTree,
  Hierarchy
} from './hierarchical-tree.js';

import PaginatedResources from './paginated_resources.js';

import Storage from './storage/index.js';

import CalculationSandbox from './calculation_sandbox.js';

export default Libs = {CurrentAttributes, DomMaster, Ajax, Clipboard, FileUploader, Geolocation, GlobalID, HierarchicalTreeNode, HierarchicalTree, Hierarchy, PaginatedResources, Storage, Qiniu: Storage, CalculationSandbox};
